module.exports = __webpack_public_path__ + "mobile/img/Outbound-banner.db41235d.png";